import React from 'react'
import PropTypes from 'prop-types'

import { Typography, Box, Stack } from '@mui/material'

import EmailAttachmentItem from './EmailAttachmentItem'

const EmailAttachmentsSection = ({ title, attachments }) => {
  if (!attachments || attachments.length === 0) return null

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body1" color="text.secondary" fontWeight={600} sx={{ mb: 1, display: 'block' }}>
        {title}
      </Typography>
      <Stack spacing={1}>
        {attachments.map((attachment, index) => (
          <EmailAttachmentItem key={attachment.bucketObjectName || index} attachment={attachment} />
        ))}
      </Stack>
    </Box>
  )
}

EmailAttachmentsSection.propTypes = {
  title: PropTypes.string.isRequired,
  attachments: PropTypes.array,
}

export default EmailAttachmentsSection
